import React from 'react';

const Footer: React.FC = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '24px 0',
        color: 'rgba(0,0,0,0.45)',
        fontSize: 14,
        background: 'none',
      }}
    >
      <div>Powered by KAIYA</div>
      <div>浙江开亚国际供应链有限公司</div>
    </div>
  );
};

export default Footer;
